// Explicit page imports for esbuild (it doesn't support import.meta.glob).
// Add new pages here as you create them.
import Gallery from './Gallery'
import CareLog from './CareLog'
import Members from './Members'
import Settings from './Settings'
import Account from './Account'
import AuthSignIn from './auth/SignIn'
import AuthRequestAccess from './auth/RequestAccess'

const pages = {
  Gallery,
  CareLog,
  Members,
  Settings,
  Account,
  'auth/SignIn': AuthSignIn,
  'auth/RequestAccess': AuthRequestAccess,
}

export default function resolvePage(name) {
  const page = pages[name]
  if (!page) {
    throw new Error(`Page not found: ${name}`)
  }
  return page
}
